import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Lightning, List, X } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function Nav() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [showFinishers, setShowFinishers] = useState(false);
  const isActive = (p) => loc.pathname === p;

  useEffect(() => {
    api.get("/config").then((r) => setShowFinishers(r.data?.show_finisher_wall !== false)).catch(() => {});
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);

  const link = (to, label, tid) => (
    <Link
      key={to}
      to={to}
      data-testid={tid}
      className={`px-3 py-2 text-xs font-display tracking-widest transition-colors ${isActive(to) ? "text-[#FF3B30]" : "text-white/80 hover:text-white"}`}
    >
      {label}
    </Link>
  );

  const mobileLink = (to, label, tid) => (
    <Link
      key={to}
      to={to}
      data-testid={tid}
      onClick={() => setOpen(false)}
      className={`block px-4 py-3.5 text-sm font-display tracking-widest border-b border-white/5 transition-colors ${isActive(to) ? "text-[#FF3B30]" : "text-white/80 hover:text-white"}`}
    >
      {label}
    </Link>
  );

  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="main-nav">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-8 h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <div className="w-8 h-8 border border-[#FF3B30] flex items-center justify-center">
            <Lightning size={18} weight="fill" color="#FF3B30" />
          </div>
          <span className="font-display text-lg tracking-widest">ALLIED<span className="text-[#FF3B30]">/RUN</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {link("/", "HOME", "nav-home")}
          {link("/register", "REGISTER", "nav-register")}
          {link("/check", "MY DASHBOARD", "nav-check")}
          {link("/leaderboard", "LEADERBOARD", "nav-leaderboard")}
          {showFinishers && link("/finishers", "FINISHERS", "nav-finishers")}
        </nav>
        <Link to="/admin/login" className="btn-outline text-xs py-2 px-4 hidden md:inline-flex" data-testid="nav-admin-btn">ADMIN</Link>
        <button
          className="md:hidden text-white/80 hover:text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="nav-menu-btn"
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden border-t border-white/10 bg-[#0A0A0A]/95 backdrop-blur-md" data-testid="mobile-menu">
          {mobileLink("/", "HOME", "mnav-home")}
          {mobileLink("/register", "REGISTER", "mnav-register")}
          {mobileLink("/check", "MY DASHBOARD", "mnav-check")}
          {mobileLink("/leaderboard", "LEADERBOARD", "mnav-leaderboard")}
          {showFinishers && mobileLink("/finishers", "FINISHERS", "mnav-finishers")}
          {mobileLink("/admin/login", "ADMIN", "mnav-admin")}
        </nav>
      )}
    </header>
  );
}
